module.exports = __webpack_public_path__ + "static/assets/e17c3cb0a043f1b81f933deb1ca3da28.png";